<section class="form-wrapper">
  <mat-card appearance="outlined" class="form-wrapper__settings">
    <mat-card-header>
      <mat-card-title>
        Accessory: {{ accessoryName }}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>

      @if (showVersionTable) {
        <mat-progress-spinner mode="indeterminate" [diameter]=20></mat-progress-spinner>
      }

      @if (!showVersionTable) {
        <app-version-table [versionData]="versionData()"
          (showSelectedVersionData)="showSelectedVersionData($event)"
        (showSelectedVersionRadioBtn)="showSelectedVersionRadioBtn($event)"></app-version-table>
      }

      @if (showAccessoryForm) {
        <div class="container mat-elevation-z8" novalidate>
          <form [formGroup]="accessoryForm" class="form" (ngSubmit)="onSave()">
            <mat-form-field class="form-element">
              <mat-label>name</mat-label>
              <input matInput placeholder="name" formControlName="name">
            </mat-form-field>
            <mat-form-field class="form-element">
              <mat-label>type</mat-label>
              <input matInput placeholder="type" formControlName="type">
            </mat-form-field>
            <div class="form-element" formArrayName="extraAttributes">
              <mat-card-subtitle>Extra Attributes</mat-card-subtitle>
              @for (qc of extraAttributes.controls; track qc; let i = $index) {
                <div [formGroupName]="i" class="query-row">
                  <mat-form-field appearance="fill" class="form-element">
                    <mat-label>Attribute</mat-label>
                    <input matInput formControlName="field" placeholder="Enter field" />
                  </mat-form-field>
                  <mat-form-field appearance="fill" class="form-element">
                    <mat-label>Value</mat-label>
                    <input matInput formControlName="value" placeholder="Enter value" />
                  </mat-form-field>
                  <button mat-icon-button color="warn" type="button"
                    (click)="removeExtraAttribute(i); $event.stopPropagation();">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              }
              <button mat-raised-button color="primary" type="button"
                (click)="addExtraAttribute(); $event.stopPropagation();">
                Add Attribute
              </button>
            </div>
            <div class="form-element spacer">
              <app-overview-editor [jsonInput]="myAccessory.overview"
              (overviewChange)="onOverviewChange($event)">‚</app-overview-editor>
            </div>
            <div class="form-element spacer">
              <mat-card-subtitle>Upload PDF Template</mat-card-subtitle>
              <app-pdf-upload [accessoryUuid]="accessoryUuid" [pictureUuid]="pictureUuid"
              (uploadComplete)="onPdfUploadComplete($event)"></app-pdf-upload>
            </div>
            @if(!pictureUuid) {
              <mat-form-field class="form-element">
                <mat-label>pdf_template</mat-label>
                <input matInput placeholder="pdf_template" formControlName="picture_uuid" [value]="pictureUuid" disabled>
              </mat-form-field>
            }
            <app-drawing-view class="form-wrapper__view-wrapper" data-testid="drawing" formControlName="drawing"
              (urlChange)="onDrawingSelect($event)">
            </app-drawing-view>
            <app-picture-select-new class="form-wrapper__picture-wrapper" formControlName="picture"
              (urlChange)="onPictureSelect($event)">
            </app-picture-select-new>
            <mat-form-field class="form-element">
              <mat-label>status</mat-label>
              <input matInput placeholder="status" formControlName="status">
            </mat-form-field>
            <mat-form-field class="form-element">
              <mat-label>comment</mat-label>
              <input matInput placeholder="comment" formControlName="comment">
            </mat-form-field>
            <mat-form-field class="form-element">
              <mat-label>category</mat-label>
              <input matInput placeholder="category" formControlName="category">
            </mat-form-field>
            <mat-form-field class="form-element">
              <mat-label>controller</mat-label>
              <mat-select formControlName="controller" multiple>
                @for (controller of ['PS','PS2' , 'PS3', 'PSk2', 'PSk3']; track controller) {
                  <mat-option [value]="controller">{{controller}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="form-element">
              <mat-label>pump_family</mat-label>
              <mat-select formControlName="pump_family" multiple>
                @for (family of ['Submersible','Surface']; track family) {
                  <mat-option [value]="family">{{family}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <app-pump-system-portfolio formControlName="portfolio_rights"
            class="form-element"></app-pump-system-portfolio>
            <mat-form-field class="form-element">
              <mat-label>pump_type</mat-label>
              <mat-select formControlName="pump_type" multiple>
                @for (type of ['Default', 'Custom', 'GRUNDFOS', 'Lowara', 'C', 'CS', 'BOOST', 'HR', 'AHR', 'HRE', 'SHRE',
                  'AHRE']; track type) {
                  <mat-option [value]="type">{{type}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-slide-toggle formControlName="secondary_accessory"
            class="form-element">secondary_accessory</mat-slide-toggle>
            @if(accessoryForm.controls['secondary_accessory'] && accessoryForm.controls['secondary_accessory'].value ===
              true) {
              <mat-form-field class="form-element">
                <mat-label>secondary_to</mat-label>
                <mat-select formControlName="secondary_to" [compareWith]="compareFn" multiple required>
                  @for (accessory of accessoryList; track accessory) {
                    <mat-option [value]="accessory">{{accessory.name}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            <app-packaging-select formControlName="packaging"></app-packaging-select>
            <mat-form-field class="form-element">
              <mat-label>item_no_1</mat-label>
              <input matInput placeholder="item_no_1" formControlName="item_no_1">
            </mat-form-field>
            <!-- <mat-form-field class="form-element">
            <mat-label>item_no_2</mat-label>
            <input matInput placeholder="item_no_2" formControlName="item_no_2">
          </mat-form-field>
          <mat-form-field class="form-element">
            <mat-label>item_no_3</mat-label>
            <input matInput placeholder="item_no_3" formControlName="item_no_3">
          </mat-form-field>
          <mat-form-field class="form-element">
            <mat-label>item_no_4</mat-label>
            <input matInput placeholder="item_no_4" formControlName="item_no_4">
          </mat-form-field>
          <mat-form-field class="form-element">
            <mat-label>item_no_5</mat-label>
            <input matInput placeholder="item_no_5" formControlName="item_no_5">
          </mat-form-field>
          <mat-form-field class="form-element">
            <mat-label>item_no_6</mat-label>
            <input matInput placeholder="item_no_6" formControlName="item_no_6">
          </mat-form-field>
          <mat-form-field class="form-element">
            <mat-label>item_no_7</mat-label>
            <input matInput placeholder="item_no_7" formControlName="item_no_7">
          </mat-form-field>
          <mat-form-field class="form-element">
            <mat-label>item_no_8</mat-label>
            <input matInput placeholder="item_no_8" formControlName="item_no_8">
          </mat-form-field>
          <mat-form-field class="form-element">
            <mat-label>item_no_9</mat-label>
            <input matInput placeholder="item_no_9" formControlName="item_no_9">
          </mat-form-field>
          <mat-form-field class="form-element">
            <mat-label>item_no_10</mat-label>
            <input matInput placeholder="item_no_10" formControlName="item_no_10">
          </mat-form-field>
          -->
          <mat-form-field class="form-element">
            <mat-label>product_name_1</mat-label>
            <input matInput placeholder="product_name_1" formControlName="product_name_1">
          </mat-form-field>
          <!--           <mat-form-field class="form-element">
          <mat-label>product_name_2</mat-label>
          <input matInput placeholder="product_name_2" formControlName="product_name_2">
        </mat-form-field>
        <mat-form-field class="form-element">
          <mat-label>product_name_3</mat-label>
          <input matInput placeholder="product_name_3" formControlName="product_name_3">
        </mat-form-field>
        <mat-form-field class="form-element">
          <mat-label>product_name_4</mat-label>
          <input matInput placeholder="product_name_4" formControlName="product_name_4">
        </mat-form-field>
        <mat-form-field class="form-element">
          <mat-label>product_name_5</mat-label>
          <input matInput placeholder="product_name_5" formControlName="product_name_5">
        </mat-form-field>
        <mat-form-field class="form-element">
          <mat-label>product_name_6</mat-label>
          <input matInput placeholder="product_name_6" formControlName="product_name_6">
        </mat-form-field>
        <mat-form-field class="form-element">
          <mat-label>product_name_7</mat-label>
          <input matInput placeholder="product_name_7" formControlName="product_name_7">
        </mat-form-field>
        <mat-form-field class="form-element">
          <mat-label>product_name_8</mat-label>
          <input matInput placeholder="product_name_8" formControlName="product_name_8">
        </mat-form-field>
        <mat-form-field class="form-element">
          <mat-label>product_name_9</mat-label>
          <input matInput placeholder="product_name_9" formControlName="product_name_9">
        </mat-form-field>
        <mat-form-field class="form-element">
          <mat-label>product_name_10</mat-label>
          <input matInput placeholder="product_name_10" formControlName="product_name_10">
        </mat-form-field>
        -->
        <div class="form-element">
          <button mat-raised-button color="primary" type="submit" class="button" data-testid="submit"
          [disabled]="!isDirty">Save Form</button>
        </div>
      </form>
    </div>
  }
</mat-card-content>
</mat-card>
</section>
